import(/* webpackMode: "eager" */ "/codebuild/output/src2968885716/src/apps/fanychance/src/app/error.tsx");
